var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-steps',{attrs:{"current":_vm.datalist.length-1}},_vm._l((_vm.datalist),function(item){return _c('a-step',{key:item.id,attrs:{"title":_vm.moment(new Date(item.createAt)).format('YYYY-MM-DD HH:mm:ss'),"description":_vm.$t(item.status)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }